module.exports = __webpack_public_path__ + "static/media/Platformicon03@2x.4dbef628.png";